import { useState, type FormEvent } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';

const navItems = [
  { label: '首页', to: '/' },
  { label: '电影', to: '/category/movie' },
  { label: '电视剧', to: '/category/tv' },
  { label: '关于我们', to: '/about-us' },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();

  const handleSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const trimmed = keyword.trim();
    if (!trimmed) return;
    navigate(`/search?q=${encodeURIComponent(trimmed)}`);
    setMenuOpen(false);
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `px-3 py-2 text-sm font-medium rounded-md transition-colors whitespace-nowrap cursor-pointer ${
      isActive
        ? 'text-primary-700 bg-primary-100'
        : 'text-foreground-700 hover:text-primary-700 hover:bg-primary-50'
    }`;

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-lg">
              <i className="ri-movie-2-line"></i>
            </span>
            <span className="font-heading font-bold text-lg text-foreground-950 whitespace-nowrap">
              秋霞电影网
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === '/'}>
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <form onSubmit={handleSearch} className="hidden md:flex items-center">
              <div className="flex items-center bg-background-100 border border-background-200 rounded-md pl-3 pr-1 h-9 focus-within:border-primary-400">
                <i className="ri-search-line text-foreground-500 text-sm"></i>
                <input
                  type="text"
                  name="q"
                  value={keyword}
                  onChange={(event) => setKeyword(event.target.value)}
                  placeholder="搜索影视名称"
                  className="w-40 lg:w-52 bg-transparent px-2 text-sm text-foreground-900 placeholder:text-foreground-500 focus:outline-none"
                />
                <button
                  type="submit"
                  className="h-7 px-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  搜索
                </button>
              </div>
            </form>

            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setMenuOpen((prev) => !prev)}
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
            >
              <i className={menuOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 pb-4 animate-fade-in">
          <form onSubmit={handleSearch} className="flex items-center gap-2 py-3">
            <div className="flex-1 flex items-center bg-background-100 border border-background-200 rounded-md pl-3 pr-2 h-10">
              <i className="ri-search-line text-foreground-500 text-sm"></i>
              <input
                type="text"
                name="q"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜索影视名称"
                className="flex-1 bg-transparent px-2 text-sm text-foreground-900 placeholder:text-foreground-500 focus:outline-none"
              />
            </div>
            <button
              type="submit"
              className="h-10 px-4 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 cursor-pointer whitespace-nowrap"
            >
              搜索
            </button>
          </form>
          <nav className="flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-2.5 rounded-md text-sm font-medium cursor-pointer ${
                    isActive ? 'text-primary-700 bg-primary-100' : 'text-foreground-700 hover:bg-background-100'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}